namespace advisorop.components.servicer {

    export class AdobesignIntegrationRequestController {

        static $inject = ["generalService", "servicerService"];
        constructor(private generalService: services.GeneralService,
            private servicerService: services.ServicerService) {
        }

        adobeSignLinkRequest(): void {
            this.servicerService.adobesignIntegrationCheck()
                .then(data => {
                    var proceed: Boolean = true;
                    if (data.data == "ALREADY_LINKED") {
                        proceed = confirm(`It looks like your account is already linked. Link again?`);
                    }
                    if (proceed) {
                        this.servicerService.adobesignIntegrationRequest()
                            .then(data => {
                                window.open(data.data, "_blank");
                            })
                            .catch(err => { this.generalService.showError(err); });
                    } else {
                        toastr.warning("You have decided not to link at this time.");
                    }
                })
                .catch(err => { toastr.error("Error."); });
        }

        $onInit(): void {

        };

        $onChanges(evt): void {
        }

    }

    class AdobesignIntegrationRequest implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "router": "<",
            };
            this.controller = AdobesignIntegrationRequestController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/adobesign-integration-request.html';
        }
    }
    angular.module(Constants.APP).component("adobesignIntegrationRequest", new AdobesignIntegrationRequest());
}